<template>
  <div>
    <div class="sm:flex sm:items-center">
      <div class="sm:flex-auto">
        <h1 class="text-base font-semibold leading-6 text-gray-900">Question Options</h1>
        <p class="mt-2 text-sm text-gray-700">A list of all the Question options.</p>
      </div>
      <div class="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
<!--        <RouterLink type="button" :to="{name: 'QuestionOptionsGroupOptionCreate', params: {question_options_group_id: questionOptionsGroupId} }" class="block rounded-md bg-gray-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">Add Option</RouterLink>-->
      </div>
    </div>
    <div class="mt-8 flow-root">
      <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">

        <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <table class="min-w-full divide-y divide-gray-300">
            <thead>
            <tr>
              <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900 sm:pl-0">ID</th>
              <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900">Text</th>
              <th scope="col" class="px-3 py-1 text-left text-sm font-semibold text-gray-900"></th>
            </tr>
            </thead>
            <tbody class="divide-y divide-gray-200">
            <tr v-for="item in items" :key="item.id">
              <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.id }}</td>
              <td class="whitespace-nowrap px-3 py-1 text-sm text-gray-500">{{ item.text }}</td>

              <td class="relative whitespace-nowrap py-1 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
<!--                <RouterLink type="button" :to="{ name: 'QuestionOptionsGroupOptionUpdate', params: { question_options_group_id: questionOptionsGroupId, id: item.id } }" class="network-button-color hover:text-gray-900">-->
<!--                  <PencilSquareIcon class="m-1 h-6 w-6" aria-hidden="true" />-->
<!--                </RouterLink>-->
<!--                <a @click="destroy(item.id)" type="button" class="network-button-color hover:text-gray-900">-->
<!--                  <TrashIcon class="m-1 h-6 w-6" aria-hidden="true" />-->
<!--                </a>-->
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <PaginationComponent :response="meta" @setPage="getItems"></PaginationComponent>
    </div>
  </div>

</template>

<script>
import PaginationComponent from "../../TwPaginationComponent.vue";
import {EyeIcon, PencilSquareIcon, TrashIcon} from "@heroicons/vue/20/solid";

export default {
  name: "QuestionOptionIndexComponent",
  data() {
    return {
      items: [],
      meta: {},
      page: null,
      thisPage: null
    }
  },
  components: {
    PaginationComponent,
    EyeIcon,
    PencilSquareIcon,
    TrashIcon,
  },
  computed: {
    questionOptionsGroupId() {
      return this.$route.params.id ? parseInt((this.$route.params.id)) : null;
    },
  },
  methods: {
    getItems(page = null) {
      this.thisPage = page;
      axios.get(`/member-firm/question-option/${this.questionOptionsGroupId}/index?page=${page}`).then((res) => {
        this.items = res.data.data;
        this.meta = res.data.meta;
      }).catch((error) => {
        console.log('error', error)
      })
    },
    destroy(id) {
      if(confirm("Do you really want to delete?")) {
        axios.delete(`/member-firm/question-option/destroy/${id}`).then((res) => {
          this.$notify({ type: "success", title: "Successfully", text: res.data.message });
          this.getItems();
        }).catch((error) => {
          console.log('error', error)
          this.$notify({ title: "Unsuccessfully", text: error.message });
        })
      }
    },
  },
  mounted() {
    this.getItems();
  },
}
</script>